// extracted by mini-css-extract-plugin
export default {"check":"styles_check__LQ7f2"};